/*
 * Copyright (C) Serfim TIC
 * All rights reserved
 */
class BaseController {
    constructor(configuration, notificationService, waitSpinnerService, $q, $state, $stateParams, $log) {
        this.configuration = configuration;
        this.notificationService = notificationService;
        this.waitSpinnerService = waitSpinnerService;
        this.$q = $q;
        this.$state = $state;
        this.$stateParams = $stateParams;
        this.$log = $log;
    }

    $onInit() {
        this.validationErrors = null;
    }

    /**
     * Handles a call to a REST service and the potential errors received, by registering an error callback to a submit
     * promise. Errors are handled unless there is a 401 or 403 HTTP status. In this later case, nothing is done as such
     * statuses are handled globally by another component.
     *
     * @param {Promise} submitPromise A promise of the form submission (i.e. a service call).
     * @param {Function} successCallback A callback that will be called if the REST service call succeeds.
     */
    handleRestServiceCall(submitPromise, successCallback) {
        let promise = submitPromise;
        if (successCallback) {
            promise = promise.then(successCallback);
        }
        return promise.then(response => {
            this.validationErrors = null;
            return response;
        }).catch(response => {
            if ((response.status !== 401) && (response.status !== 403)) {
                this.handleResponseError(response);
            }
            return response.data;
        });
    }

    /**
     * Handles client errors received after a failed form submission (HTTP statuses 4xx), and pushes notifications in
     * the UI.
     *
     * @param {Object} response The response data.
     */
    handleResponseError(response) {
        if ((response.status >= 400) && (response.status < 500)) {
            this.validationErrors = response.data.validationErrors;
            if (response.data.errors) {
                for (const errorCode in response.data.errors) {
                    if (response.data.errors.hasOwnProperty(errorCode)) {
                        this.notificationService.pushMessageWithParameters(`api.error.${errorCode}`,
                            response.data.errors[errorCode], this.configuration.NOTIFIER_LEVEL_ERROR);
                    }
                }
            } else {
                this.notificationService.pushMessage(`server.error.${response.status}`,
                    this.configuration.NOTIFIER_LEVEL_ERROR);
            }
        }
    }

    /**
     * Tells whether some attachments don't exceed the maximum file size.
     *
     * @param {FileList} attachments Attachments.
     * @return {Boolean} true if attachments are valid.
     */
    areAttachmentsValid(attachments) {
        let largeFileExists = false;
        for (let i = 0; i < attachments.length; i++) {
            if (attachments[i].size > (this.configuration.UPLOAD_MAX_FILE_SIZE * Math.pow(1024, 2))) {
                largeFileExists = true;
                break;
            }
        }
        if (largeFileExists) {
            this.notificationService.pushMessageWithParameters('ui.curativeaction.attachmenttoolarge',
                { maxFileSize: this.configuration.UPLOAD_MAX_FILE_SIZE }, this.configuration.NOTIFIER_LEVEL_WARN);
        }
        return !largeFileExists;
    }
}

export { BaseController };



// WEBPACK FOOTER //
// ./src/main/front/scripts/module/BaseController.js